import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ImageTransformationModule } from '@vendasta/image-transformation';
import { VaIconModule } from '@vendasta/uikit';
import { VaPricingModule } from './pricing/pricing.module';
import { StoreCardComponent } from './store-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from './assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from './shared/constants';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { BillingUiModule } from '@vendasta/billing-ui';

@NgModule({
  imports: [
    CommonModule,
    VaIconModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    ImageTransformationModule,
    VaPricingModule,
    TranslateModule,
    GalaxyTooltipModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    BillingUiModule,
  ],
  declarations: [StoreCardComponent],
  exports: [StoreCardComponent],
})
export class StoreCardModule {}
